import { render, staticRenderFns } from "./account-messages.vue?vue&type=template&id=734f3181&"
import script from "./account-messages.vue?vue&type=script&lang=js&"
export * from "./account-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports